import { render } from "./Blank.vue?vue&type=template&id=8741adf2&scoped=true"
const script = {}

import "./Blank.vue?vue&type=style&index=0&id=8741adf2&scoped=true&lang=scss"

import exportComponent from "/Users/andersnielsen/Sites/demo-leverandoroverblik/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8741adf2"]])

export default __exports__